import AuthRepository from "./AuthRepository";
import BlogsRespository from "./BlogsRespository";
import CategoriesRepository from "./CategoriesRepository";
import CertificationRepository from "./CertificationRepository";
import ChatRepository from "./ChatRepository";
import DashboardRepository from "./DashboardRepository";
import DisputesRepository from "./DisputesRepository";
import OrderRepository from "./OrderRepository";
import PolicyRepository from "./PolicyRepository";
import ReportRepository from "./ReportRepository";
import ResolutionTeamRespository from "./ResolutionTeamRespository";
import SupportPersonRespository from "./SupportPersonRespository";
import TicketsRespository from "./TicketsRespository";
import UsersRepository from "./UsersRepository";
import deletedJobRepository from "./deletedJobRepository";
import taxRepository from "./taxRepository";
import adminsRepository from "./AdminRepository";
import CheckrReportRepository from "./CheckrReportRepository";
import HelpArticleRepository from "./HelpArticleRepository";
import SkillsRepository from "./SkillsRepository";
import NameRequestRepository from "./NameRequestRepository";
import SalesRepository from "./SalesRepository";
import EquipmentsRepository from "./EquipmentsRepository";
import WorkTypeRepository from "./WorkTypeRepository";
import ServicesRepository from "./ServicesRepository";
import WorkOrderRepository from "./WorkOrderRepository";
import WaitlistRepository from "./WaitlistRepository";
import ChatbotKnowledgeRepository from "./ChatbotKnowledgeRepository";

const repositories = {
  auth: AuthRepository,
  support: SupportPersonRespository,
  resolution: ResolutionTeamRespository,
  blogs: BlogsRespository,
  users: UsersRepository,
  stats: DashboardRepository,
  tickets: TicketsRespository,
  policy: PolicyRepository,
  category: CategoriesRepository,
  certification: CertificationRepository,
  tax: taxRepository,
  workOrder: WorkOrderRepository,
  orders: OrderRepository,
  disputes: DisputesRepository,
  reports: ReportRepository,
  chats: ChatRepository,
  deletedJobs: deletedJobRepository,
  admins: adminsRepository,
  checkrReports: CheckrReportRepository,
  helpArticles: HelpArticleRepository,
  skills: SkillsRepository,
  nameRequests: NameRequestRepository,
  sales: SalesRepository,
  equipments: EquipmentsRepository,
  workType: WorkTypeRepository,
  services: ServicesRepository,
  waitlist: WaitlistRepository,
  chatbotKnowledge: ChatbotKnowledgeRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
